"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { getAiContextLabel } from "@/lib/ai/context";
import { recordAiBrowsingEvent } from "@/lib/ai/storage/browsing-memory";

export function AiBrowsingTracker() {
	const pathname = usePathname();

	useEffect(() => {
		if (!pathname || pathname.startsWith("/ai")) {
			return;
		}

		void recordAiBrowsingEvent({
			pathname,
			label: getAiContextLabel(pathname),
			source: "navigation",
			title: typeof document !== "undefined" ? document.title : undefined,
		});
	}, [pathname]);

	return null;
}
